
export declare type DataQueryStatement = DataQueryCriteriaStatement|string
export interface DataQueryCriteriaStatement{
    fieldName: string;
    op: '>='|'<='|'!='|'<>'|'>'|'<'|'='|'NOT LIKE'|'LIKE'|'IN'|string;
    value: string|number;
}

export const CriteriaQueryBuilder = function(){
    function build(op:'and'|'or' = 'and', statements:DataQueryStatement[], doEncodeURI: boolean = false) : string{
        if(statements.length == 0) return "";
        const parsedStatements = statements.map(statement=>{
            if(typeof(statement) === 'string') return statement;
            return `${statement.fieldName} ${statement.op} ${statement.value}`;
        });
        let result;
        if(parsedStatements.length == 1) result = parsedStatements[0];
        else result = JSON.stringify({ op: op, simpleStatements: parsedStatements });
        return doEncodeURI?encodeURI(result):result;
    }
    function buildOpAnd(statements:DataQueryStatement[], doEncodeURI: boolean = false): string{
        return build("and", statements, doEncodeURI);
    }
    function buildOpOr(statements:DataQueryStatement[], doEncodeURI: boolean = false): string{
        return build("or", statements, doEncodeURI);
    }

    return {
        build: build,
        buildOpAnd: buildOpAnd,
        buildOpOr: buildOpOr
    }
}();
